<template>
  <v-app >
    <v-navigation-drawer style=" position: fixed" class="pt-15"
                     v-model="drawer" width="230" absolute permanent hide-overlay :expand-on-hover="$vuetify.breakpoint.xsOnly">
      <v-list
        nav
        rounded
      >
        <v-list-item>
        <v-list-item-icon>
          <v-icon>
            mdi-format-list-bulleted
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="title">
            Category
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
        <v-list-item-group
          v-model="selectedItem"
          color="primary"
        >
        <v-list-item
          v-for="item in items"
          :key="item.title"
          @click="handleClick(item.components)"
          :disabled="item.disable ==='true'"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <div class="d-flex" >
      <v-main style="width: 5%">
      </v-main>
      <v-main style="width: 85%; margin: auto;" class="pa-0" >
        <component style="margin: auto" v-bind:is="category"/>
      </v-main>
      <v-main style="width: 15%; " class="ml-n16">
      <v-img style="width: 8%; position: fixed" :src="require('../assets/Legend.png')">
      </v-img>
      </v-main>
    </div>
  </v-app>
</template>

<script>
import RISK from '@/components/Risk_mindmap.vue'
import KPI from '@/components/KPI_mindmap.vue'
import SALES from '@/components/Sales_mindmap.vue'
import INSTORE from '@/components/Instore_mindmap.vue'
import MARKET from '@/components/Market_mindmap.vue'
import OPERATION from '@/components/Operation_mindmap.vue'
import PRODUCT from '@/components/Product_mindmap.vue'
export default {
  name: "mindmap",
  components: {
      RISK,
      KPI,
      SALES,
      MARKET,
      OPERATION,
      PRODUCT,
      INSTORE
    },
  data () {
      return {
        drawer:true,
        items: [
          { title: 'Key Reports', icon: 'mdi-image-filter-center-focus-strong', components:'KPI', disable:'false'},
          { title: 'Sales Reports', icon: 'mdi-account-tie', components: 'SALES', disable:'false'},
          { title: 'Instore Reports', icon: 'mdi-storefront-outline', components: 'INSTORE', disable:'false'},
          { title: 'Risk Reports', icon: 'mdi-target-account', components: 'RISK', disable:'false'},
          { title: 'Marketing Reports', icon: 'mdi-account-group-outline' , components: 'MARKET', disable:'false'},
          { title: 'Operation Reports', icon: 'mdi-account-network', components: 'OPERATION', disable:'false' },
          { title: 'Product Reports', icon: 'mdi-arrange-bring-forward', components: 'PRODUCT', disable:'false' },
        ],
        category:'KPI',
        email:'bi@afterpay.com',
        selectedItem:0
      }
    },
  methods:{
      handleClick:function (component){
        this.category = component;
      }
    }
}

</script>

<style scoped>

</style>
